import React from 'react'

export const SearchIcon = ({ ...props }) => (
  <div {...props}>
    <svg
      stroke='#4F4F4F'
      fill='none'
      strokeWidth='2'
      viewBox='0 0 24 24'
      strokeLinecap='round'
      strokeLinejoin='round'
      height='24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>Search</title>
      <circle cx='11' cy='11' r='8'></circle>
      <line x1='21' y1='21' x2='16.65' y2='16.65'></line>
    </svg>
  </div>
)

export const CloseIcon = ({ ...props }) => (
  <div {...props}>
    <svg width='18' viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg'>
      <title>Close</title>
      <path
        fill='#4F4F4F'
        d='M9.00023 7.58599L13.9502 2.63599L15.3642 4.04999L10.4142 8.99999L15.3642 13.95L13.9502 15.364L9.00023 10.414L4.05023 15.364L2.63623 13.95L7.58623 8.99999L2.63623 4.04999L4.05023 2.63599L9.00023 7.58599Z'
      />
    </svg>
  </div>
)
